import mapValuesToRequest from './mappers/mapValuesToRequest'
import { UpdateLimitType } from './index'

export default function(api: GlobalFetch) {
  return async function(userId, type: UpdateLimitType) {
    const requestBody = mapValuesToRequest(userId, type)
    await api.fetch('/api/v2/limit/index/', {
      body: JSON.stringify(requestBody),
      method: 'PUT',
    })
  }
}
